import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';


@Component({
    templateUrl: './revalidation.component.html',
    styleUrls: ['../style/_dashboard.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RevalidationComponent implements OnInit {


  ngOnInit() { }


}
